import { Button } from "../Button"
import "./styles.scss"

const ReportPathTopicsHeader = ({ data, setModalIsOpen }) => {
  const hasImage = data.image ? data.image : `https://ui-avatars.com/api/?name=${data.title}`
  return (
    <div className="report-charts-section-header">
      <div className="header-info">
        <div className="header-info-image" style={{ backgroundImage: `url(${hasImage})` }} />
        <h2>{data.title}</h2>
      </div>
      <div className="header-button-add">
        <Button
          color="orange"
          label="Editar Lista"
          handleClick={() => setModalIsOpen({ newListIsOpen: true })}
        />
        <Button
          color="orange"
          label="Novo Tópico"
          handleClick={() => setModalIsOpen({ newPathTopicsIsOpen: true })}
        />
      </div>
    </div>
  )
}

export default ReportPathTopicsHeader
